// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"0977b23c","358":"e1bf0021","420":"12baea42","571":"d3983495","672":"6eb05a7f","870":"6f4cc27e"}[chunkId] + ".chunk.js";
};